export default __webpack_public_path__ + "static/media/44.70add5b3.jpg";